import { NumberFormatter, NumberFormatterProps } from "@mantine/core";

const CustomNumberFormatter = (props: NumberFormatterProps) => {
  return (
    <NumberFormatter
      decimalScale={2}
      suffix={' CHF'}
      decimalSeparator={'.'}
      thousandSeparator={','}
      {...props}
    />
  )
}

export default CustomNumberFormatter;